/**设置firebase跟踪代码 */
export default function (data, event = "screen_view") {
  if (window.firebaseAnalytics) {
    if (event === "screen_view" && data.firebase_screen) {
      let sData = Object.assign({}, data);
      delete sData.firebase_screen;
      firebaseAnalytics.setCurrentScreen(data.firebase_screen, sData);
    }
    firebaseAnalytics.logEvent(event, data);
  }
  if (window._paq) {
    const path = location.href.split("?")[0].split("#")[1];
    window._paq.push(["trackEvent", path, event, data]);
  }
}
